export const applyDiscount = (value: number, discount: number) =>
  value - (value * discount) / 100;
